/**
 * Service Worker Rules Machine Bundle
 *
 * Этот файл экспортирует createRulesMachine и createActor для использования в service worker.
 * Собирается в отдельный bundle через webpack.
 */

// Импортируем и реэкспортируем для гарантии включения в bundle
import { createRulesMachine as _createRulesMachine } from '@ally/calendar-client-react/machines/rulesMachine';
import { createActor as _createActor } from 'xstate';

// Явно экспортируем для включения в bundle
export const createRulesMachine = _createRulesMachine;
export const createActor = _createActor;

// Для Service Worker: экспорты должны быть в self.__SW_RULES_EXPORTS__
const workerScope = typeof globalThis !== 'undefined' ? globalThis : undefined;
if (workerScope) {
  workerScope.__SW_RULES_EXPORTS__ = { createRulesMachine, createActor };
}
